import dailyGuidance from "@/assets/img/landing/daily-guidance.webp"
import gift from "@/assets/img/landing/gift.webp"
import checkIcon from "@/assets/svg/landing/check.svg"
import { Button } from "@/components/ui/button"

import { ADVANTAGES } from "../../config/landing-content"
import { SectionTitle } from "../section-title"

interface AdvantagesSectionProps {
  onAction: () => void
}

export function AdvantagesSection({ onAction }: AdvantagesSectionProps) {
  return (
    <section data-slot="advantages-section" className="flex flex-col px-4">
      <SectionTitle>Everything You Need for Daily Guidance</SectionTitle>

      <img src={dailyGuidance} alt="" className="mt-4 w-full" />

      <div className="mt-6 flex flex-col gap-6">
        <div className="flex flex-col gap-4">
          {ADVANTAGES.map((item) => (
            <div key={item.title} className="flex h-16 items-center gap-4">
              <div className="flex h-full items-center rounded-full bg-green/10 px-2">
                <img src={checkIcon} alt="" className="h-[13px] w-[18px]" />
              </div>
              <div className="flex min-w-0 flex-1 flex-col gap-1">
                <h3 className="font-display text-base font-medium text-purple-light">
                  {item.title}
                </h3>
                <p className="text-sm leading-snug text-purple-light/70">{item.subtitle}</p>
              </div>
            </div>
          ))}

          {/* Personal gift card */}
          <div className="flex flex-col overflow-hidden rounded-[16px]">
            <div className="flex items-center justify-center rounded-t-[16px] bg-green px-2 py-1">
              <p className="text-xs font-bold text-dark-base">PERSONAL GIFT INCLUDED</p>
            </div>
            <div className="flex items-end gap-2 rounded-b-[16px] bg-gradient-to-r from-purple-light/5 to-purple-light/20 pr-4">
              <div className="relative size-[94px] shrink-0 overflow-hidden">
                <div className="absolute left-[-42.82px] top-[-13.82px] flex size-[150.644px] items-center justify-center">
                  <img src={gift} alt="" className="size-[123px] -rotate-15 object-cover" />
                </div>
              </div>
              <div className="flex min-w-0 flex-1 flex-col justify-center gap-0.5 self-stretch py-2">
                <h3 className="font-display text-base font-medium text-purple-light">
                  Free 3-minute reading
                </h3>
                <p className="text-sm leading-snug text-purple-light/70">
                  Ask your question and get guidance from an astrologer.
                </p>
              </div>
            </div>
          </div>
        </div>

        <Button variant="gradient" size="xl" onClick={onAction}>
          Get My Insights
        </Button>
      </div>
    </section>
  )
}
